<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Automoderation</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('automod.create')">
        <span>Add</span>
        <span class="hidden md:inline">Automoderation</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Enabled</th>
          <th class="px-6 pt-6 pb-4">Term</th>
          <th class="px-6 pt-6 pb-4">Action</th>
          <th class="px-6 pt-6 pb-4">Reason</th>
<!--          <th class="px-6 pt-6 pb-4">Stream Title Hashtags</th>
          <th class="px-6 pt-6 pb-4">Stream Tags</th>
          <th class="px-6 pt-6 pb-4">Stream Category</th>-->
        </tr>
        <tr v-for="automod in automods.data" :key="automod.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('automod.edit', automod.id)" tabindex="-1">
              {{ automod.is_enabled == true ? "🟢" : "🔴" }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-2 flex items-center focus:text-indigo-500" :href="route('automod.edit', automod.id)">
                {{ automod.term }}
              <icon v-if="automod.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-2 flex items-center focus:text-indigo-500" :href="route('automod.edit', automod.id)">
              <template v-if='automod.type=="timeout"'>
              {{ automod.type }} ({{ (automod.duration) }} sec) 
              </template>
              <template v-else>
                 {{ automod.type }}
              </template>
              <icon v-if="automod.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-2 flex items-center focus:text-indigo-500" :href="route('automod.edit', automod.id)">
                {{ automod.reason }}
              <icon v-if="automod.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <!--
            <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('announcements.edit', announcement.id)" tabindex="-1">
              {{ announcement.stream_title_hashtag }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('announcements.edit', announcement.id)" tabindex="-1">
              {{ announcement.stream_tags }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('announcements.edit', announcement.id)" tabindex="-1">
              {{ announcement.stream_game }}
            </inertia-link>
          </td>
          -->
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('automod.edit', automod.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="automods.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No terms that are currently automoderated.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="automods.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Automoderation' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    automods: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      }
    }
  },
  computed: {
    nodes(message) {
        console.log(message)
        return message.split(' ')
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('automod'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
